/* Gazelle Glam — rails + scroll reveal. Defer-load after theme.js. */
(function () {
  function tween(el, to) {
    var from = el.scrollLeft, t0 = Date.now();
    if (el.__tw) clearInterval(el.__tw);
    el.__tw = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / 320);
      el.scrollLeft = from + (to - from) * (1 - Math.pow(1 - p, 3));
      if (p >= 1) { clearInterval(el.__tw); el.__tw = null; sync(el); }
    }, 16);
  }
  function sync(rail) {
    var wrap = rail.closest('.gg-rail-wrap');
    if (!wrap) return;
    var max = rail.scrollWidth - rail.clientWidth;
    var x = Math.abs(rail.scrollLeft);
    var prev = wrap.querySelector('.gg-arrow--prev');
    var next = wrap.querySelector('.gg-arrow--next');
    if (max <= 8) { if (prev) prev.hidden = true; if (next) next.hidden = true; return; }
    if (prev) { prev.hidden = false; prev.disabled = x < 8; }
    if (next) { next.hidden = false; next.disabled = x > max - 8; }
  }
  function initRail(rail) {
    var wrap = rail.closest('.gg-rail-wrap');
    if (!wrap || wrap.__init) return;
    wrap.__init = true;
    var rtl = document.documentElement.getAttribute('dir') === 'rtl' ? -1 : 1;
    wrap.querySelectorAll('.gg-arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.classList.contains('gg-arrow--next') ? 1 : -1;
        var step = Math.max(260, rail.clientWidth * 0.72) * dir * rtl;
        var max = rail.scrollWidth - rail.clientWidth;
        tween(rail, Math.max(-max, Math.min(max, rail.scrollLeft + step)));
      });
    });
    rail.addEventListener('scroll', function () { sync(rail); }, { passive: true });
    sync(rail);
  }
  function reveal() {
    var els = document.querySelectorAll('.gg-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) el.classList.add('is-in');
      else io.observe(el);
    });
  }
  function boot() {
    document.querySelectorAll('.gg-rail').forEach(initRail);
    reveal();
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('resize', function () {
    document.querySelectorAll('.gg-rail').forEach(sync);
  });
})();